import HomeMap from './HomeMap'
import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => {
  return {
    regionsData: state.REGIONS.regionsData,
    countriesData: state.REGIONS.countriesData
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSelectedRegionId: selectedRegionId => dispatch(ReduxActions.setSelectedRegionId(selectedRegionId))
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HomeMap)
)



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/HomeMap/index.js